var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.697392 17.3476C0.696362 20.3072 1.47312 23.1964 2.94959 25.7429L0.555664 34.4446L9.50064 32.1096C11.9653 33.4475 14.7401 34.1528 17.5639 34.1538H17.5711C26.8704 34.1538 34.4406 26.6197 34.4446 17.3611C34.4461 12.8738 32.6923 8.65448 29.5069 5.48034C26.3209 2.30655 22.0847 0.557543 17.5711 0.555664C8.27005 0.555664 0.701167 8.08856 0.697392 17.3476ZM6.02419 25.3044L5.69029 24.7766C4.28623 22.5541 3.54516 19.9858 3.54619 17.3486C3.54928 9.65291 9.84038 3.39192 17.5764 3.39192C21.3226 3.39346 24.8434 4.84729 27.4915 7.48523C30.1395 10.1233 31.5966 13.6302 31.5956 17.36C31.5922 25.0559 25.3009 31.3177 17.5711 31.3177H17.5656C15.0486 31.3164 12.5802 30.6435 10.4274 29.3719L9.91501 29.0694L4.60692 30.4549L6.02419 25.3044Z",
    fill: "url(#paint0_linear_321_875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27801 17.353C1.27715 20.2098 2.02697 22.9992 3.45266 25.4578L1.1416 33.8583L9.77687 31.6042C12.1559 32.895 14.8346 33.5764 17.5607 33.5771H17.5679C26.5452 33.5771 33.8529 26.3046 33.8567 17.3658C33.8584 13.0342 32.1656 8.96125 29.0899 5.89695C26.0148 2.83282 21.925 1.14446 17.5673 1.14258C8.589 1.14258 1.28179 8.41463 1.27801 17.353Z",
    fill: "url(#paint1_linear_321_875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3537 10.3273C13.0379 9.62835 12.7055 9.61434 12.4051 9.60204C12.1592 9.59162 11.878 9.59229 11.5971 9.59229C11.3158 9.59229 10.8591 9.69753 10.4729 10.1174C10.0863 10.5374 8.99707 11.5528 8.99707 13.6178C8.99707 15.683 10.508 17.6785 10.7186 17.9588C10.9294 18.2386 13.6353 22.6119 17.9206 24.2943C21.4822 25.6924 22.2069 25.4143 22.9799 25.3443C23.7529 25.2744 25.4744 24.3293 25.8256 23.3491C26.177 22.3691 26.177 21.5291 26.0717 21.3536C25.9663 21.1787 25.6851 21.0737 25.2635 20.8639C24.8418 20.654 22.769 19.6384 22.3826 19.4984C21.996 19.3585 21.715 19.2886 21.4338 19.7088C21.1527 20.1285 20.3452 21.0737 20.0992 21.3536C19.8533 21.6341 19.6073 21.6691 19.1857 21.4592C18.7639 21.2486 17.406 20.8058 15.7952 19.3761C14.5418 18.2635 13.6957 16.8896 13.4497 16.4694C13.2038 16.0497 13.4234 15.8224 13.6348 15.6131C13.8242 15.425 14.0565 15.123 14.2674 14.8781C14.4778 14.633 14.548 14.458 14.6885 14.1781C14.8292 13.8979 14.7588 13.6528 14.6535 13.4429C14.548 13.2329 13.7287 11.1573 13.3537 10.3273Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_875",
    x1: 1695,
    y1: 3389.45,
    x2: 1695,
    y2: 0.55122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_875",
    x1: 1636.9,
    y1: 3272.72,
    x2: 1636.9,
    y2: 1.14414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.97a5e1556278538a14ad318d607fcbe8.svg";
export { ForwardRef as ReactComponent };